import {
  Checkbox,
  CheckboxOverrides,
  CheckboxProps,
  LABEL_PLACEMENT,
} from 'baseui/checkbox';
import { CheckboxCheckedSVG, CheckboxIndeterminateSVG } from 'common/assets';
import { themedStyled } from 'common/styles/styletron.theme';
import * as React from 'react';
import merge from 'ts-deepmerge';

interface CheckBoxInputProps extends CheckboxProps {}
export default function CheckBoxInput(props: CheckBoxInputProps) {
  const { children, ...restProps } = props;

  const overrides = merge(
    {
      Toggle: {
        style: ({ $checked, $theme }) => ({
          backgroundColor: $checked ? $theme.colors.secondaryDark : 'white',
        }),
      },
      ToggleTrack: {
        style: ({ $theme }) => ({
          backgroundColor: $theme.colors.skyLighter,
        }),
      },
      Root: {
        style: {
          width: 'fit-content',
        },
      },
      Checkmark: {
        component: ({ $checked, $isIndeterminate, $disabled }) => {
          if ($isIndeterminate)
            return (
              <IndeterminateBox $disabled={$disabled}>
                <CheckboxIndeterminateSVG />
              </IndeterminateBox>
            );
          else if ($checked)
            return (
              <CheckedBox $disabled={$disabled}>
                <CheckboxCheckedSVG />
              </CheckedBox>
            );
          return <UncheckedBox $disabled={$disabled} />;
        },
      },
    } as CheckboxOverrides,
    { ...props.overrides },
  );

  return (
    <Checkbox
      {...restProps}
      labelPlacement={LABEL_PLACEMENT.right}
      overrides={overrides}
    >
      {children}
    </Checkbox>
  );
}

const CheckedBox = themedStyled<'div', { $disabled: boolean }>(
  'div',
  ({ $theme, $disabled }) => ({
    width: '20px',
    height: '20px',
    minWidth: '20px',
    minHeight: '20px',
    borderRadius: '2px',
    background: $disabled
      ? $theme.colors.skyLight
      : $theme.colors.primaryDefault,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2px',
  }),
);

const UncheckedBox = themedStyled<'div', { $disabled: boolean }>(
  'div',
  ({ $theme, $disabled }) => ({
    width: '20px',
    height: '20px',
    minWidth: '20px',
    minHeight: '20px',
    borderWidth: '1.6px',
    borderColor: $disabled ? $theme.colors.skyLight : $theme.colors.inkLightest,
    borderStyle: 'solid',
    borderRadius: '2px',
    margin: '2px',
  }),
);

const IndeterminateBox = themedStyled<'div', { $disabled: boolean }>(
  'div',
  ({ $theme, $disabled }) => ({
    width: '20px',
    height: '20px',
    minWidth: '20px',
    minHeight: '20px',
    borderRadius: '2px',
    background: $disabled
      ? $theme.colors.skyLight
      : $theme.colors.primaryDefault,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2px',
  }),
);
